module.exports = __webpack_public_path__ + "static/media/help_business_profile_menu.746ee8d9.jpg";